import React from 'react'
import { Modal } from 'react-bootstrap';
import DraggableComponent from './DraggableComponent';

const GenericPopup = ({ header, mode, onClose, size, children, className, action = true, centeredHeader = false }: any) => {

  return (
    <>
    {mode && 
      <Modal show={mode} centered dialogAs={DraggableComponent} id="devEstPopup" className={className ? className: undefined} size={size?size:undefined} >
        <div className="modal-content new-interchange" id="devEstContentPopup">
          {action && <Modal.Header className="modal-header" closeButton={false} style={centeredHeader ? { display: 'flex', justifyContent: 'center', position: 'relative' } : undefined}>
            <h5 className="modal-title mt-0" style={{
              minWidth: "100px", 
              maxWidth: "800px", 
              overflowWrap: "break-word",
              ...(centeredHeader ? { margin: '0 auto' } : {})
            }}>{`${mode === "add" ? "Add" : mode === "edit" ? "Edit" : ""} ${header}`}</h5>
            <button type="button" className="isModal" data-dismiss="modal" style={{ 
              marginLeft: "0px", 
              background: "none",
              ...(centeredHeader ? { position: 'absolute', right: '15px' } : {})
            }}
              aria-label="Close"
              onClick={()=>{onClose()}}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </Modal.Header>}
          <div className="modal-body">{children}</div>
        </div>
      </Modal>}
    </>
  );
};

export default GenericPopup
